export default [
  {
    name: 'DocumentTypesList',
    path: '/settings/document-types',
    component: () => import('pages/settings/document-types/DocumentTypesList.vue')
  },
  {
    name: 'DocumentTypesCreate',
    path: '/settings/document-types/new',
    component: () => import('pages/settings/document-types/DocumentTypesForm.vue')
  },
  {
    name: 'DocumentTypesEdit',
    path: '/settings/document-types/:id/edit',
    component: () => import('pages/settings/document-types/DocumentTypesForm.vue')
  }
]
